import { Link } from "react-router-dom";
import { ShieldCheck, UserPlus } from "lucide-react";
import { useAuth } from "@/lib/auth";
import type { Listing } from "@/lib/types";

export default function ClaimListing({ listing }: { listing: Listing }) {
  const { user } = useAuth();

  // Hide if already claimed or if user is logged in (listings are tied to email)
  if (listing.is_claimed || user) return null;

  return (
    <div className="p-5 rounded-2xl border border-primary/20 bg-primary/5">
      <div className="mb-3">
        <div className="w-9 h-9 rounded-xl bg-primary/15 flex items-center justify-center mb-3">
          <ShieldCheck className="w-5 h-5 text-primary" />
        </div>
        <h3 className="font-semibold text-foreground text-sm mb-1">
          Is this your business?
        </h3>
        <p className="text-xs text-muted-foreground leading-relaxed mb-2">
          Claim this listing to manage your profile and unlock premium features and boost your SEO Rankings!
        </p>
        <p className="text-xs font-medium text-primary/90 leading-relaxed px-3 py-2 rounded-lg bg-primary/10 border border-primary/15">
          Register with the email address on file for this business to verify ownership.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <Link
          to="/register?type=provider"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <UserPlus className="w-4 h-4" />
          Claim This Listing
        </Link>
        <Link
          to={`/claim-help?listing=${listing.slug}`}
          className="text-xs text-muted-foreground hover:text-primary transition-colors underline underline-offset-2"
        >
          Can't access that email?
        </Link>
      </div>
    </div>
  );
}
